/* eslint-disable import/prefer-default-export */
import * as ReduxHelpers from '@src/utils/reduxHelpers'
const prefix = 'cam/auth'

//Action Types
export const GET_STAT_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_STAT_SUCCESS'
)
export const GET_PROGRESS_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_PROGRESS_SUCCESS'
)

export const GET_TENANT_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_TENANT_SUCCESS'
)
export const GET_USER_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_USER_SUCCESS'
)
export const GET_NOTIFICATIONS_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'GET_NOTIFICATIONS_SUCCESS'
)
export const SIGN_OUT_SUCCESS = ReduxHelpers.Types.createActionType(
  prefix,
  'SIGN_OUT_SUCEESS'
)
export const SERVER_ERRORS = ReduxHelpers.Types.createActionType(
  prefix,
  'AUTH_SERVER_ERRORS'
)
export const REQUEST_PENDING = ReduxHelpers.Types.createActionType(
  prefix,
  'REQUEST_PENDING'
)
export const REQUEST_PENDING_PROGRESS = ReduxHelpers.Types.createActionType(
  prefix,
  'REQUEST_PENDING_PROGRESS'
)
export const ACCOUNT_REGISTER_PENDING = ReduxHelpers.Types.createActionType(
  prefix,
  'ACCOUNT_REGISTER_PENDING'
)
export const LOGGED_IN = ReduxHelpers.Types.createActionType(
  prefix,
  'LOGGED_IN'
)

export const LOGGED_OUT = ReduxHelpers.Types.createActionType(
  prefix,
  'LOGGED_OUT'
)

export const SET_SNAPSHOT_STATE = ReduxHelpers.Types.createActionType(
  prefix,
  'SET_SNAPSHOT_STATE'
)

export const SET_SOURCES_IMPROVEMENTS_FF = ReduxHelpers.Types.createActionType(
  prefix,
  'SET_SOURCES_IMPROVEMENTS_FF'
)

export const SET_IDN_API_URL = ReduxHelpers.Types.createActionType(
  prefix,
  'SET_IDN_API_URL'
)
